// Query keys are scoped by the active org id so that an org switch (new
// X-OptiID-Org-Id from Prism) re-fetches everything without a full reload.
export const queryKeys = {
  apiKeys: {
    status: (orgId: string | null) => ['api-keys', 'status', orgId] as const,
  },
  apps: {
    list: (orgId: string | null) => ['apps', 'list', orgId] as const,
    // excludeStates is part of the key: each filter is a different result set and is cached
    // separately. Callers pass it pre-sorted (see useAppVersions) so the same set in a
    // different order is one cache entry, not two.
    versions: (orgId: string | null, appId: string, excludeStates: readonly string[]) =>
      ['apps', 'versions', orgId, appId, excludeStates] as const,
    installations: (orgId: string | null, appId: string) =>
      ['apps', 'installations', orgId, appId] as const,
  },
};
